import {CanActivateFn, Router} from '@angular/router';
import {inject} from "@angular/core";
import {AuthService} from "@/pages/service/auth.service";


export const authGuard: CanActivateFn = () => {
    const auth = inject(AuthService);
    const router = inject(Router);

    if (auth.isTokenValid()) {
        return true;
    }
    return router.navigate(['/login']);
};
